<script setup lang="ts">
import { Link } from "@inertiajs/vue3";
</script>

<template>
    <Link :href="'/'">
        <img alt="Fattoria Le Pupille" class="w-32" src="/logo.png" />
    </Link>
</template>
